/* istanbul ignore file */
import { createUseStyles } from '@glu/theming';

export default createUseStyles(({ nav: { horiz } }) => ({
  icon: {}, // required for $icon style definition below

  root: {
    position: 'absolute',
    background: horiz.dropdown.backgroundColor,
    zIndex: 99,
    top: horiz.tier0.linkHeight + horiz.borderBottomWidth,
    left: ({ alignRight }) => (alignRight ? 'auto' : 0),
    right: ({ alignRight }) => (alignRight ? 0 : 'auto'),
    padding: [13, 0],
    boxShadow: horiz.dropdown.boxShadow,
    minWidth: 250,
    maxWidth: 320,
    listStyleType: 'none',
    '& a, & button': {
      background: 'transparent',
      border: 0,
      color: horiz.tier1.linkColor,
      cursor: 'pointer',
      display: 'block',
      fontFamily: horiz.userLink.fontFamily,
      fontSize: 16,
      fontWeight: 300,
      height: 34,
      lineHeight: '34px',
      padding: [0, horiz.tier1.linkPadding],
      position: 'relative',
      textAlign: 'left',
      textDecoration: 'none',
      whiteSpace: 'nowrap',
      width: '100%',
      '& svg': {
        height: 16,
        width: 16,
        fill: horiz.tier1.linkColor,
        position: 'relative',
        top: 2
      },
      '&:hover, &:focus': {
        background: horiz.tier1.linkHoverBackground,
        '&::after': {
          display: 'none'
        },
        outline: 'none'
      }
    }
  }

}));
